module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael Cobley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Michael Cobley")]), _vm._v(" was born in Leicester, England and has lived in Glasgow, Scotland for most of his life. He has studied engineering, been a DJ and has an abiding interest in democratic politics. "), _c('br'), _c('br'), _vm._v("His previous books include the Shadowkings dark fantasy trilogy and "), _c('I', [_vm._v("Iron Mosaic")]), _vm._v(", a short story collection. "), _c('I', [_vm._v("Seeds of Earth, The Orphaned Worlds")]), _vm._v(", and "), _c('I', [_vm._v("The Ascendant Stars")]), _vm._v(", books one, two and three of the Humanity's Fire sequence, were his first full-length forays into space opera.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1CwfI9c/tc-custom/9780316515160.jpg?1741987337911",
      "alt": "This image is the cover for the book Splintered Suns, Humanity's Fire"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Splintered Suns, Humanity's Fire\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("The “proper galaxy-spanning space opera” series continues with a treasure hunt that could unlock an advanced civilization's lost technologies (Ian M. Banks).")])]), _c('p', [_vm._v("For Pyke and his crew of thieves, the plan was simple enough: Travel to a backwater desert planet, break into a museum, steal a tracking device, then use it to find a ship buried in the planet's vast and trackless sandy wastes.")]), _c('p', [_vm._v("Except that the museum vault is a bio-engineered chamber, and the tracking device is sought-after by another gang of treasure hunters led by an old adversary of Pyke's, the devious Raven Kaligara. Also, the ship is a quarter of a million years old, about two kilometers long, and somewhere onboard is a mysterious relic that promises to unlock all the treasures and technologies of a lost civilization…")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Orbit\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0